var desvg = require('.')
var h = require('preact').h

module.exports = desvg.bind(null, h)
